export default "__VITE_ASSET__7c63e7a3__"